module.exports = __webpack_public_path__ + "img/no_active_horn.60bf2781.svg";